import { getModelAssetMetadata as e } from "../utils/getModelAssetMetadata.js";
import { useEffect as t, useState as n } from "react";
//#region src/lib/hooks/useGetModelStatistics.ts
var r = async (t) => {
	let n = await (await fetch(t)).blob();
	return await e(new File([n], "asset-statistics.glb"), {
		calculateStatistics: !0,
		calculateExtents: !0
	});
}, i = (e) => {
	let [i, a] = n(!1), [o, s] = n(), [c, l] = n(), [u, d] = n(), [f, p] = n(), [m, h] = n(), [g, _] = n(), [v, y] = n();
	return t(() => {
		e && (a(!0), (async () => {
			let t = await r(e);
			s(t?.vertexCount), l(t?.meshCount), d(t?.meshVram), p(t?.textureCount), h(t?.textureVram), _(t?.materialCount), y(t?.extents);
		})().catch((e) => {
			s(void 0), l(void 0), d(void 0), p(void 0), h(void 0), _(void 0), y(void 0), console.warn(`Failed to get model statistics: ${e instanceof Error ? e.message : String(e)}`);
		}).finally(() => a(!1)));
	}, [e]), {
		loading: i,
		vertexCount: o,
		meshCount: c,
		meshVram: u,
		textureCount: f,
		textureVram: m,
		materialCount: g,
		meshExtents: v
	};
};
//#endregion
export { r as calculateModelStatistics, i as useGetModelStatistics };
